<template>
  <div class="card">
    <div class="between">
      <h3>需求发布公告</h3>
      <div class="moreBtn" @click="onShowMore">更多</div>
    </div>
    <template v-if="showList.length > 0">
      <div class="p-y-10 b-line pointer" v-for="(item, index) in showList" :key="index" @click="onShowDetail(item)">
        <div class="flex-line-center">
          <div class="title">{{ item.projectName }}</div>
          <div class="ml-8">
            <!--  1- 已接单, 2- 已完成, 3- 已过期, -->
            <span class="tag1" v-if="item.ssoDemandStatus == 1">已接单</span>
            <span class="tag2" v-if="item.ssoDemandStatus == 2">已完成</span>
            <span class="tag3" v-else-if="item.ssoDemandStatus == 3">已过期</span>
          </div>
        </div>
        <div class="between">
          <div>
            <span class="label">发布时间：</span><span class="time">{{ item.publishTime || '-' }}</span>
          </div>
          <div>
            <span class="label">有效期至：</span><span class="time">{{ item.validityPeriod || '-' }}</span>
          </div>
        </div>
      </div>
    </template>
    <el-empty v-else description="暂无内容"  >
      <template :slot="'image'"><span></span></template>
    </el-empty>
    <NoticeList ref="noticeList"></NoticeList>
    <NoticeDetail ref="noticeDetail" />
  </div>
</template>

<script>
import NoticeList from "../../notice/list.vue";
import NoticeDetail from "../../notice/detail.vue";

export default {
  components: {
    NoticeList,
    NoticeDetail
  },
  data() {
    return {
      showList: [],
      page: {
        page: 1,
        limit: 3
      }
    };
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$http.post(`/front/oms/omsSsoDemand/page`, { ...this.page }).then(({ data: res }) => {
        if (res.code === 0 && res.data) {
          console.log(res.data);
          this.showList = res.data.records || []
        }
      })
    },
    onShowMore() {
      this.$refs.noticeList.onShow();
    },
    onShowDetail(res) {
      console.log(res);
      this.$refs.noticeDetail.onShow(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 20px;
  width: 400px;
  height: 254px;
}

h3 {
  margin: 0;
}

.p-y-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.flex {
  display: flex;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
}

.title {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.txt {
  font-family: Alibaba PuHuiTi;
  font-size: 12px;
}

.label {
  @extend .txt;
  color: #666666;
}

.time {
  @extend .txt;
  font-weight: 600;
  color: #333333;
}

.ml-8 {
  margin-left: 8px;
}

.tag {
  @extend .txt;
  color: #ffffff;
  display: inline-block;
  height: 20px;
  line-height: 16px;
  border-radius: 10px;
  padding: 2px 8px;
}

.tag1 {
  @extend .tag;
  background: #1fbd13;
}

.tag2 {
  @extend .tag;
  background: #2a54d1;
}

.tag3 {
  @extend .tag;
  background: #ccc;
}

.b-line {
  border-bottom: 1px solid #eeeeee;
}

.flex-line-center {
  display: flex;
  align-items: center;
}

.moreBtn {
  font-size: 14px;
  color: #999999;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
}

.pointer {
  cursor: pointer;
}
</style>